<mat-toolbar class="bg-tricon-beige">
  Income Requirement
  <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<mat-dialog-content>
  <p>The household income of all Applicant(s) must have a minimum combined gross income of three (3) times the monthly rent.</p>
  <p>Would you like to review the household income?</p>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col justify-center w-full">
  <div class="w-full">
      <div>
          <button mat-flat-button style="width:100%" color="primary" mat-dialog-close>YES</button>
      </div>
      <div>
          <button mat-flat-button style="width:100%" class="mt-4" color="primary" mat-dialog-close="scheduletour">NO</button>
      </div>
  </div>
</mat-dialog-actions>
